import React from 'react';

import { type EmotionCache, MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

import { MantineDatesProviderLocale } from '@/utils/enums';

import 'dayjs/locale/en';
import 'dayjs/locale/nl';
import 'dayjs/locale/nl-be';

interface IAdminMantineProvider {
  children: React.ReactNode;
  emotionCache?: EmotionCache;
}

const AdminMantineProvider = ({ children, emotionCache }: IAdminMantineProvider) => {
  const datesProviderLocale = MantineDatesProviderLocale.ENGLISH;

  return (
    <MantineProvider
      emotionCache={emotionCache}
      theme={{
        colors: {
          brand: [
            '#E7FAF8',
            '#CFF6F1',
            '#B7F1EB',
            '#88E8DD',
            '#9FEDE4',
            '#10D1BB',
            '#10D1BB',
            '#08B39F',
            '#04A693',
            '#037A6D',
          ],
          red: [
            '#F69FAA',
            '#F48C99',
            '#F27988',
            '#F16577',
            '#EF5266',
            '#ED3F55',
            '#D5394D',
            '#BE3244',
            '#8E2633',
            '#691923',
          ],
        },
        primaryColor: 'brand',
        // Determines whether elements that do not have pointer cursor by default
        // (checkboxes, radio, native select) should have it
        cursorType: 'pointer',
        fontFamily: 'Gotham, sans-serif',
      }}
    >
      <DatesProvider
        settings={{
          firstDayOfWeek: 1,
          locale: datesProviderLocale,
        }}
      >
        {children}
      </DatesProvider>
    </MantineProvider>
  );
};

export { AdminMantineProvider as MantineProvider };
